import { createContext } from 'react';

export { default as ServiceGroupsProvider } from './ServiceGroupsProvider';
export { default as ServicesProvider } from './ServicesProvider';

export const ServiceGroupContext = createContext({});
export const ServiceContext = createContext({});
